import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  align?: 'left' | 'center';
  as?: 'h2' | 'h3';
  id?: string;
  children?: React.ReactNode;
}
export function SectionHeading({
  eyebrow,
  title,
  align = 'center',
  as: Tag = 'h2',
  id,
  children
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center items-center' : 'text-left items-start';
  return <div className={`flex flex-col ${alignment}`} data-id="element-149" data-mp="bk3o7m5caz8v">
      {eyebrow ? <span className="mb-5 text-[0.68rem] font-medium uppercase tracking-[0.32em] text-accent-soft" data-id="element-150" data-mp="gj6u18t599hw">
          {eyebrow}
        </span> : null}
      <Tag id={id} className="font-display text-[1.75rem] font-light leading-tight tracking-[0.06em] text-frost sm:text-4xl lg:text-[2.6rem]" data-id="element-151" data-mp="1u0vln24rnb2">
        {title}
      </Tag>
      <span aria-hidden="true" className={`mt-6 block h-px w-24 bg-gradient-to-r from-transparent via-silver/50 to-transparent ${align === 'center' ? '' : 'bg-gradient-to-r from-silver/50 to-transparent'}`} data-id="element-152" data-mp="uig0hgrjsp8o" />
      {children ? <div className="mt-7 w-full" data-id="element-153" data-mp="1obe8glnwf77r">{children}</div> : null}
    </div>;
}